import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/system"
import { Skeleton, Typography } from "@mui/material"
import theme from "../../theme/theme"

const InfoItem = ({
    label,
    value,
    loading,
    optionalText,
    optionalTextLabel,
    optionalTextOpacity,
    optionalTextVariant,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                minWidth: 0,
                width: "100%",
            }}
        >
            <Typography
                variant="contraHeading"
                sx={{
                    color: theme.palette.primary.white70,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                }}
            >
                {label}
            </Typography>

            {loading ? (
                <Skeleton
                    variant="text"
                    animation="wave"
                    width="70%"
                    height={28}
                    sx={{
                        bgcolor: theme.palette.primary.white70,
                        opacity: 0.25,
                    }}
                />
            ) : (
                <Typography
                    variant="textBody"
                    color="common.white"
                    sx={{
                        whiteSpace: "pre-line",
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                    }}
                >
                    {value ?? "-"}
                </Typography>
            )}

            {!loading && optionalTextLabel && (
                <Typography
                    variant="contraHeading"
                    sx={{
                        color: theme.palette.primary.white70,
                        mt: 1,
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                    }}
                >
                    {optionalTextLabel}
                </Typography>
            )}

            {!loading && optionalText && (
                <Typography
                    variant={optionalTextVariant}
                    color="common.white"
                    sx={{
                        whiteSpace: "pre-line",
                        opacity: optionalTextOpacity,
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                    }}
                >
                    {optionalText}
                </Typography>
            )}
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
    ]),
    loading: PropTypes.bool,
    optionalText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
    ]),
    optionalTextLabel: PropTypes.string,
    optionalTextOpacity: PropTypes.number,
    optionalTextVariant: PropTypes.string,
}

InfoItem.defaultProps = {
    value: "-",
    loading: false,
    optionalText: null,
    optionalTextLabel: null,
    optionalTextOpacity: 1,
    optionalTextVariant: "textBody",
}

export default InfoItem